import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import PopularVideosSection from './components/PopularVideosSection';
import CreatorSection from './components/CreatorSection';
import DownloadCTASection from './components/DownloadCTASection';
import FAQSection from './components/FAQSection';
import { faqData } from '@/mocks/categories';

const siteUrl = 'https://www.91short.com';

const schemaData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '91short短视频平台',
      url: siteUrl,
      description: '91short是专注于短视频内容创作与分享的平台，汇聚海量优质短视频资源。',
      sameAs: [
        'https://weibo.com/91short',
        'https://www.weixin.com/91short',
      ],
    },
    {
      '@type': 'WebSite',
      name: '91short短视频平台',
      url: siteUrl,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '91short短视频平台 - 首页',
      url: siteUrl,
      isPartOf: { '@type': 'WebSite', name: '91short', url: siteUrl },
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqData.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="91short短视频平台 - 发现精彩短视频，记录生活每一刻 | 91short官网"
        description="91short是专注于短视频内容创作与分享的平台，汇聚海量优质短视频资源。在91short，你可以发现最热门的短视频内容，轻松创作、上传和分享你的精彩瞬间，加入91short开启你的短视频之旅。"
        keywords="91short,91short短视频,91short平台,91short官网,91short下载,91short创作者,91short热门视频"
        canonicalUrl={siteUrl}
        schemaData={schemaData}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <PopularVideosSection />
        <CreatorSection />
        <DownloadCTASection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}